var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-house"},[_c('house-editor',{attrs:{"type":"addHouse","canLeave":_vm.canLeave},on:{"update:canLeave":function($event){_vm.canLeave=$event},"update:can-leave":function($event){_vm.canLeave=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }